import type { FileEntry, FileSortDir, FileSortKey } from '@/types/SixDetail.types';

export function getNextSortDir(
  currentKey: FileSortKey,
  currentDir: FileSortDir,
  nextKey: FileSortKey,
): FileSortDir {
  return currentKey === nextKey && currentDir === 'asc' ? 'desc' : 'asc';
}

export function getCreatedByLabel(item: FileEntry): string {
  return item.createdByUser ?? item.uploadedByUser ?? '-';
}

export function getPathLabel(item: FileEntry): string {
  if (item.isNavigationEntry === true) {
    return '-';
  }

  return typeof item.path === 'string' && item.path.length > 0 ? item.path : '/';
}
